export default {
    META_TITLE: "Marhaf Chamie | Lead AI Engineer",
    META_DESCRIPTION:
        "Portfolio of Marhaf Chamie, Lead AI Engineer building GenAI & agentic AI systems — multi-agent orchestration, RAG/GraphRAG, evaluation frameworks, MCP — with 11 years of full-stack production experience across fintech, healthcare, mobility, and AI.",
    META_AUTHOR: "Marhaf Chamie",
    META_IMAGE: "https://marhaf-chamie.web.app/og-image.jpg",
    META_TWITTER_HANDLE: "@inmogr",
    META_TWITTER_CARD: "summary_large_image",
    META_OG_TYPE: "website",
    SITE_TITLE: "Marhaf Chamie",
    SITE_URL: "https://marhaf-chamie.web.app",
    NAV_ABOUT: "About",
    NAV_EXPERIENCE: "Experience",
    NAV_SKILLS: "Skills",
    NAV_PROJECTS: "Projects",
    NAV_VENTURES: "Ventures",
    NAV_EDUCATION: "Education",
    NAV_TECHNOLOGIES: "Technologies",
    NAV_DEMOS: "Demos",
    NAV_CONTACT: "Contact",

    HERO_NAME: "Marhaf Chamie",
    HERO_HEADING: "11 Years Shipping Production Systems · $34M Acquisition (Blink Charging, Nasdaq: BLNK) · Led 15 Engineers",
    HERO_ROLE: "Lead AI Engineer — GenAI, Agentic Systems & Full-Stack",
    HERO_TAGLINE: "GenAI | Agentic AI | RAG/GraphRAG | Evaluation | MCP | Kubernetes | Human-in-the-Loop | React | React Native | TypeScript | Node.js | Cloud",
    HERO_VIEW_EXPERIENCE: "View Experience",
    HERO_VIEW_AI_WORK: "See My AI Work",
    HERO_CONTACT_ME: "Contact Me",
    HERO_SCROLL_LABEL: "Scroll to About section",
    HERO_BG_LOGO_ALT_SUFFIX: "logo",

    ABOUT_SUMMARY_TITLE: "Summary",
    ABOUT_PARAGRAPH1:
        "Lead AI engineer with 11 years building and shipping production software end-to-end — across fintech, healthcare, mobility, social, and SaaS, in the US, UAE, Australia, and Malaysia. Deep in applied, agentic AI (GenAI): multi-agent systems (LangGraph, LangChain), RAG/GraphRAG (LlamaIndex), evaluation frameworks, MCP, and human-in-the-loop, built into products that run in production rather than demos.",
    ABOUT_PARAGRAPH2:
        "Known for shipping unfamiliar technology fast — a Bluetooth vehicle-control SDK in six weeks, foreground/background clinical voice, first-time bank-grade encryption. Has led teams of up to 15 engineers, mentored ~20, and built systems on the team through a $34M acquisition (Blink Charging, Nasdaq: BLNK).",
    ABOUT_CONTACT_INFO: "Contact Information",
    ABOUT_LOCATION: "Dubai, UAE — Remote (any time zone)",
    ABOUT_CONTACT_LINKEDIN: "LinkedIn",
    ABOUT_CONTACT_GITHUB: "GitHub",
    ABOUT_CONTACT_SELFINTRO: "Self-Introduction",
    ABOUT_CONTACT_EMAIL: "hireme2026sep@inmogr.aleeas.com",
    ABOUT_CONTACT_LINKEDIN_URL: "https://linkedin.com/in/inmogr",
    ABOUT_CONTACT_GITHUB_URL: "https://github.com/inmogr",
    ABOUT_CONTACT_SELFINTRO_URL: "https://drive.google.com/file/d/1VWf9650iOwe2kug9WfWUYVHNkprSPN5b/view?usp=sharing",
    ABOUT_CONTACT_AI_DEMO: "AI Demo (Talk to Search)",
    ABOUT_CONTACT_AI_DEMO_2: "AI Demo (Document to Search)",
    ABOUT_CONTACT_AI_DEMO_URL: "https://youtu.be/vrleXfiLCtw",
    ABOUT_CONTACT_AI_DEMO_2_URL: "https://youtu.be/17KgPvXfRPg",
    ABOUT_CONTACT_AI_DEMO_ID: "vrleXfiLCtw",
    ABOUT_CONTACT_AI_DEMO_2_ID: "17KgPvXfRPg",

    CONTACT_SECTION_TITLE: "Get in Touch",
    CONTACT_INFO_HEADER: "Contact Information",
    CONTACT_SENDING: "Sending...",
    CONTACT_SEND_MESSAGE: "Send Message",
    CONTACT_EMAIL: "hireme2026sep@inmogr.aleeas.com",
    CONTACT_LINKEDIN_URL: "https://linkedin.com/in/inmogr",
    CONTACT_GITHUB_URL: "https://github.com/inmogr",
    CONTACT_FORM_NAME_LABEL: "Name",
    CONTACT_FORM_EMAIL_LABEL: "Email",
    CONTACT_FORM_SUBJECT_LABEL: "Subject",
    CONTACT_FORM_MESSAGE_LABEL: "Message",
    CONTACT_FORM_NAME_PLACEHOLDER: "Your name",
    CONTACT_FORM_EMAIL_PLACEHOLDER: "Your email",
    CONTACT_FORM_SUBJECT_PLACEHOLDER: "Subject",
    CONTACT_FORM_MESSAGE_PLACEHOLDER: "Your message",
    CONTACT_FORM_ERROR_NAME: "Name must be at least 2 characters",
    CONTACT_FORM_ERROR_EMAIL: "Please enter a valid email address",
    CONTACT_FORM_ERROR_SUBJECT: "Subject is required",
    CONTACT_FORM_ERROR_MESSAGE: "Message must be at least 10 characters",
    CONTACT_FORM_SUCCESS: "Message sent successfully! I'll get back to you soon.",
    CONTACT_FORM_FAILURE: "Failed to send message. Please try again later.",
    CONTACT_FORM_CAPTCHA_ERROR: "Please complete the CAPTCHA verification.",
    CONTACT_API_URL_ERROR: "VITE_CONTACT_API_URL is not defined",
    CONTACT_RECAPTCHA_NOT_READY: "Recaptcha not ready",
    CONTACT_SEND_ERROR: "Error sending message:",
    USE_FORM_FIELD_CONTEXT_ERROR: "useFormField should be used within <FormField>",

    CONTACT_LINKEDIN_ARIA_LABEL: "LinkedIn",
    CONTACT_GITHUB_ARIA_LABEL: "GitHub",
    CONTACT_EMAIL_ARIA_LABEL: "Email",

    // Menu accessibility labels
    MENU_TOGGLE_OPEN_ARIA_LABEL: "Open navigation menu",
    MENU_TOGGLE_CLOSE_ARIA_LABEL: "Close navigation menu",
    TOAST_CLOSE_ARIA_LABEL: "Close notification",

    FOOTER_TAGLINE: "Lead AI Engineer — GenAI & Agentic Systems",
    FOOTER_RIGHTS: "All rights reserved.",

    EXPERIENCE_SECTION_TITLE: "Experience",
    EXPERIENCE_JOBS: [
        {
            company: "A Team",
            companyLink: "https://a.team",
            location: "Remote · Los Angeles, United States",
            position: "Lead AI Engineer (Contract)",
            period: "Jun 2025 – Present",
            description: [
                "Built RobynnAI end-to-end alongside the founder — an agentic AI marketing platform: a multi-agent system (research, writing, analysis, and strategy agents) over a self-learning brand-memory layer, with LangChain-based RAG/GraphRAG retrieval, multi-LLM orchestration (Claude + GPT), and human-in-the-loop correction. Took it from zero to production. Recommendation letter on file.",
                "Sole engineer on RogerHealthCare, an AI clinical-documentation assistant deployed to practicing clinicians: real-time speech-to-text (Whisper + Deepgram) → LangChain/LlamaIndex-orchestrated, GraphRAG-backed multi-LLM analysis → automated document population, with foreground and background voice capture on mobile (React Native) — built first-time and shipped. Recommendation letter on file.",
                "Scoped, built, and delivered 7 AI projects end-to-end for Handshake AI under its sole-engineer-per-system model, typically running 2–3 in parallel: complete AI-system replications of established SaaS products (incl. document-workflow automation), agentic tooling (LangChain, LlamaIndex, GraphRAG), MCP servers, and evaluation quality gates — authoring several of the evaluation suites that validated system behavior before delivery.",
                "Standardized evaluation frameworks and quality gates across client systems; worked directly with founders and CEOs, translating between business goals and technical execution.",
            ],
            subtitle: "Forward-deployed AI engineer scoping, building, and shipping production AI systems end-to-end for multiple US clients.",
            caseStudies: [
                { label: "Robynn AI — case study", link: "/project/robynn" },
                { label: "Handshake AI — RLE tool fleet", link: "/project/handshake" },
            ],
        },
        {
            company: "INMOGR",
            companyLink: "https://inmogr.com",
            location: "Remote · Dubai, UAE",
            position: "Founder & AI Engineer",
            period: "May 2024 – May 2025",
            description: [
                "Designed and ran an automated AI content pipeline — script generation → video generation → AI-written SEO metadata → scheduled publishing via Google APIs — producing ~10 videos/day with no manual intervention, orchestrated on Kubernetes.",
                "Built React Native apps to monitor the pipeline and approve or adjust AI-generated steps in the loop.",
            ],
        },
        {
            company: "EnvoyThere / Blink Mobility",
            companyLink: "https://envoythere.com",
            location: "Remote · Los Angeles, United States",
            position: "Senior Full-Stack Engineer",
            period: "Sep 2022 – May 2024",
            description: [
                "Re-architected and rebuilt the entire EV car-sharing platform for scale and reliability — a microservices architecture serving two brands on shared infrastructure — and was on the engineering team through Envoy's $34M acquisition by Blink Charging (Nasdaq: BLNK).",
                "Designed and shipped a custom Bluetooth (BLE) SDK for offline and online vehicle control — with no prior Bluetooth experience, in ~6 weeks — running on 100+ vehicles, with offline command queueing and sync.",
                "Built compliant KYC onboarding (ClearMe, Checkr) with instant approve/reject, replacing multi-day manual review.",
                "Migrated the mobile app from Expo to React Native and JavaScript to TypeScript. Stack: AWS, Firebase, PostgreSQL.",
            ],
            subtitle: "EnvoyThere is a leading provider of mobility solutions, specializing in car rental platforms and integrated transportation services.",
        },
        {
            company: "Noumena",
            location: "Remote · Miami, USA",
            position: "Senior Full-Stack Engineer",
            period: "Dec 2020 – Aug 2022",
            description: [
                "Engineered a multi-step KYC loan workflow with full identity and income verification, cutting onboarding and decisioning time by ~99%.",
                "Shipped mobile video streaming for iOS and Android (React Native) and a drag-and-drop social page builder.",
                "Drove a +30% increase in user engagement through UX and performance work.",
            ],
            subtitle:
                "Noumena is a social media platform for freelancers to publicly share their services and portfolio as well as sell those services on the platform for other users.",
            caseStudies: [{ label: "Noumena for Freelancers — case study", link: "/project/noumena-freelancers" }],
        },
        {
            company: "Aleph-Labs",
            companyLink: "https://aleph-labs.com",
            location: "On-site · Kuala Lumpur, Malaysia",
            position: "Team Lead, Banking",
            period: "May 2019 – Dec 2020",
            description: [
                "Led a team of 15 engineers (front-end, back-end, QA) delivering a large banking program split into sub-systems, orchestrated on Kubernetes.",
                "Built mobile and web banking apps with real-time financial operations for CIMB, RHB, and AmBank, plus telecom work for Digi.",
                "Implemented encryption in transit and at rest for sensitive financial data — first-time, shipped to production.",
                "Delivered full digital KYC onboarding and secure admin portals with role-based access and compliance controls; mentored juniors and raised codebase quality and delivery speed.",
            ],
            subtitle:
                "Aleph-Labs is a large company in ASEAN and Australia delivering the region's biggest projects — banks, telecoms, and government. Delivered into on-prem banking environments.",
            caseStudies: [{ label: "Bank-grade mobile at Aleph-Labs — 5 case studies", link: "/project/aleph-labs" }],
        },
        {
            company: "Episub",
            companyLink: "https://episub.com",
            location: "Remote · Sydney, Australia",
            position: "Full-Stack Engineer",
            period: "Sep 2018 – May 2019",
            description: ["Built React, React Native, and Node.js web and mobile apps for university divisions and charities; delivered in Agile teams."],
            subtitle: "Episub is an Australian company that provides software solutions for university divisions and charity organizations within Sydney.",
        },
        {
            company: "Avtian",
            location: "Remote · Houston, Texas, USA",
            position: "Frontend Engineer",
            period: "May 2018 – Sep 2018",
            description: ["Built cross-browser React UI and front-end architecture for a project-management tool."],
        },
        {
            company: "Freelancer",
            location: "Kuala Lumpur, Malaysia",
            position: "Full-Stack Engineer",
            period: "Dec 2015 – Jun 2017",
            description: ["Delivered a Java condo-management web application and an iOS/Android React Native app, end-to-end."],
        },
        {
            company: "WAMY (World Assembly of Muslim Youth)",
            location: "Hybrid · Kuala Lumpur, Malaysia",
            position: "Head of Activities",
            period: "Oct 2013 – Feb 2017",
            description: [
                "Launched a social-app initiative that automated report generation, saving ~20% of manual work per week.",
                "Introduced an event-planning system that cut planning time ~15% and raised attendee satisfaction.",
            ],
            subtitle: "Part-time community leadership role alongside studies and early freelance work.",
        },
    ],

    EDUCATION_SECTION_TITLE: "Education",
    EDUCATION_CARD_TITLE: "Education",
    EDUCATION_DEGREE: "Bachelor of Science in Computer Science",
    EDUCATION_UNIVERSITY: "IIUM — CGPA 3.72 / 4.0",
    EDUCATION_CERT_TITLE: "Certifications, Publication & IP",
    EDUCATION_CERT_ITEMS: [
        "AWS Certified (×3)",
        "Google Cloud Certified (×2)",
        "Co-author, peer-reviewed conference paper on the Qaf assessment platform (2018)",
        "3 registered copyrights (UAE)",
        "Filed a banking patent as inventor (UK & UAE) — AI-driven banking process automation",
        "Languages: English (professional; IELTS 7.0 / 7.5) · Arabic (native)",
    ],

    SKILLS_SECTION_TITLE: "Skills",
    SKILLS_CATEGORIES: [
        {
            title: "GenAI & Agentic Systems",
            skills: [
                "Agentic & multi-agent systems (LangGraph, LangChain)",
                "LLM applications (Claude, GPT, Gemini, Grok)",
                "RAG & GraphRAG — multilingual, cross-encoder reranking, context engineering, graph-based retrieval",
                "LlamaIndex",
                "Evaluation frameworks & quality gates",
                "MCP servers",
                "Human-in-the-loop",
                "Prompt engineering",
                "Graphlit",
                "Self-hosted / edge inference",
            ],
        },
        {
            title: "Engineering",
            skills: ["TypeScript", "JavaScript", "Python", "React", "React Native", "Node.js / Express", "REST APIs", "Native mobile modules"],
        },
        {
            title: "Cloud & Platform",
            skills: ["AWS (primary)", "GCP", "Azure", "Kubernetes", "Docker", "CI/CD (GitHub Actions, Jenkins, Fastlane)", "Sentry", "PostHog"],
        },
        { title: "Data & Real-time", skills: ["PostgreSQL", "MySQL", "MongoDB", "Firebase", "ChromaDB (vector)", "WebSockets", "Firebase RTDB"] },
        {
            title: "Leadership & Delivery",
            skills: [
                "System architecture (microservices, modular monolith, event-driven)",
                "Technical scoping",
                "Team leadership (15+)",
                "Mentorship (~20)",
                "Stakeholder & executive translation",
                "Agile / Scrum",
            ],
        },
        {
            title: "Security & Compliance",
            skills: ["KYC / identity verification", "Encryption in transit & at rest", "Role-based access control", "AI guardrails & governance"],
        },
    ],

    PROJECTS_SECTION_TITLE: "Projects",
    PROJECTS_VIEW_PROJECT: "View Project",
    PROJECTS_VIEW_DETAILS: "View Details",
    PROJECTS_FEATURED_LABEL: "Featured",
    PROJECTS_AI_SECTION_TITLE: "AI & Agentic Systems",
    PROJECTS_PLATFORM_SECTION_TITLE: "Fintech & Platform",
    PROJECTS_AI: [
        {
            title: "Robynn AI — Agentic Marketing Platform",
            description:
                "Architected the Svelte 5 orchestration layer and visual DAG canvas — durable SSE streaming, background-execution polling, and multi-channel publishing on Supabase and a LangGraph agent service, with LangChain-based RAG/GraphRAG retrieval.",
            company: "A Team (contract)",
            link: "/project/robynn",
        },
        {
            title: "Handshake AI — RLE Tool Fleet",
            description:
                "Eight deterministic simulators of enterprise software (chemical-process simulation, contract-lifecycle management, petroleum economics, and more) as reinforcement-learning environments — MCP tool surfaces, numerical solvers, state-integrity contracts, and agentic tooling (LangChain, LlamaIndex, GraphRAG).",
            company: "Handshake AI (contract)",
            link: "/project/handshake",
        },
    ],
    PROJECTS_PAID: [
        {
            title: "Blink Mobility / BlueLA",
            description:
                "Re-architected the EV car-sharing platform; custom BLE SDK controlling 100+ vehicles; on the team through the $34M Blink Charging acquisition",
            company: "EnvoyThere",
            link: "/project/blink-mobility",
        },
        {
            title: "Noumena for Freelancers",
            description:
                "Social app for verified freelancers with an in-app lending system — built the Plaid bank-data + KYC + automated decisioning path end to end, handing approvals to a human underwriting team",
            company: "Noumena",
            link: "/project/noumena-freelancers",
        },
        {
            title: "Bank-grade mobile at Aleph-Labs",
            description:
                "Team Lead, Banking (2019–2020): five mobile products into on-premise environments — CIMB, RHB and AmBank consumer banking, the In1Bank bilingual neobank, and Digi telecom self-care.",
            company: "Aleph-Labs",
            link: "/project/aleph-labs",
        },
    ],
    PROJECTS_VENTURE_SECTION_TITLE: "Ventures",
    PROJECTS_VENTURES: [
        {
            title: "Qaf",
            description:
                "National Quran-examination platform — in production since 2017, rebuilt 26 times; a dual-database realtime architecture bridging a live exam layer to an ACID system of record",
            category: "Enterprise / Realtime",
            link: "/venture/qaf",
        },
        {
            title: "Yalla Pizza",
            description:
                "AI-driven restaurant operations product: conversational ordering bot, management bot, and real-time kitchen, stock, sales & order tracking",
            category: "AI / POS",
            link: "/venture/yalla-pizza",
        },
        {
            title: "Awaneek",
            description: "AI-powered e-commerce platform for automated product-legality verification",
            category: "AI / E-commerce",
            link: "/venture/awaneek",
        },
        {
            title: "Natrarosa",
            description: "Free online store builder for salons and flower shops",
            category: "E-commerce",
            link: "/venture/natrarosa",
        },
    ],

    TECHNOLOGIES_SECTION_TITLE: "Technologies",
    TECHNOLOGIES_LIST: [
        { name: "React Native", src: "https://cdn.worldvectorlogo.com/logos/react-native-1.svg" },
        { name: "React", src: "https://icon.icepanel.io/Technology/svg/React.svg" },
        { name: "ExpressJS", src: "https://icon.icepanel.io/Technology/png-shadow-512/Express.png" },
        { name: "TypeScript", src: "https://cdn.worldvectorlogo.com/logos/typescript.svg" },
        { name: "JavaScript", src: "https://cdn.worldvectorlogo.com/logos/javascript-2.svg" },
        { name: "Python", src: "https://cdn.worldvectorlogo.com/logos/python-5.svg" },
        { name: "ChatGPT API", src: "https://cdn.worldvectorlogo.com/logos/chatgpt-6.svg" },
        { name: "Grok API", src: "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/light/grok.png" },
        { name: "Gemini API", src: "https://upload.wikimedia.org/wikipedia/commons/8/8a/Google_Gemini_logo.svg" },
        { name: "Ollama", src: "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/light/ollama.png" },
        { name: "HuggingFace", src: "https://huggingface.co/datasets/huggingface/brand-assets/resolve/main/hf-logo.svg" },
        { name: "LangChain", src: "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/light/langchain.png" },
        { name: "LlamaIndex", src: "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/light/llamaindex.png" },
        { name: "Kubernetes", src: "https://icon.icepanel.io/Technology/svg/Kubernetes.svg" },
        { name: "Slack Bot", src: "https://cdn.worldvectorlogo.com/logos/slack-new-logo.svg" },
        { name: "Telegram Bot", src: "https://cdn.worldvectorlogo.com/logos/telegram-1.svg" },
        { name: "Shell Script Writing", src: "https://cdn.worldvectorlogo.com/logos/bash-2.svg" },
        { name: "GitHub Actions", src: "https://cdn.worldvectorlogo.com/logos/github-icon-1.svg" },
        { name: "Jenkins", src: "https://cdn.worldvectorlogo.com/logos/jenkins-1.svg" },
        { name: "Google Cloud", src: "https://cdn.worldvectorlogo.com/logos/google-cloud-2.svg" },
        { name: "AWS", src: "https://cdn.worldvectorlogo.com/logos/aws-2.svg" },
        { name: "Azure", src: "https://cdn.worldvectorlogo.com/logos/azure-1.svg" },
        { name: "Firebase", src: "https://cdn.worldvectorlogo.com/logos/firebase-2.svg" },
        { name: "Jira", src: "https://cdn.worldvectorlogo.com/logos/jira-1.svg" },
        { name: "Scrum", src: "https://cdn.worldvectorlogo.com/logos/scrum-1.svg" },
        { name: "Agile", src: "https://cdn.worldvectorlogo.com/logos/agile-software.svg" },
        { name: "NPM", src: "https://icon.icepanel.io/Technology/svg/NPM.svg" },
        { name: "Redux", src: "https://icon.icepanel.io/Technology/svg/Redux.svg" },
        { name: "Vite", src: "https://icon.icepanel.io/Technology/svg/Vite.js.svg" },
        { name: "Nginx", src: "https://icon.icepanel.io/Technology/svg/NGINX.svg" },
        { name: "Docker", src: "https://icon.icepanel.io/Technology/svg/Docker.svg" },
        { name: "Android", src: "https://icon.icepanel.io/Technology/png-shadow-512/Android-Studio.png" },
        { name: "Cloudflare", src: "https://icon.icepanel.io/Technology/svg/Cloudflare.svg" },
        { name: "EsLint", src: "https://icon.icepanel.io/Technology/svg/ESLint.svg" },
        { name: "Chrome", src: "https://icon.icepanel.io/Technology/svg/Chrome.svg" },
        { name: "Chrome Extension", src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREHWmJqswjeSOHOsd8u_zIK6Fe8_rBiJDqsQ&s" },
        { name: "GitLab", src: "https://icon.icepanel.io/Technology/svg/GitLab.svg" },
        { name: "GraphQL", src: "https://icon.icepanel.io/Technology/svg/GraphQL.svg" },
        { name: "Markdown", src: "https://icon.icepanel.io/Technology/png-shadow-512/Markdown.png" },
        { name: "Linux", src: "https://icon.icepanel.io/Technology/png-shadow-512/Linux.png" },
        { name: "MaterialUI", src: "https://icon.icepanel.io/Technology/svg/Material-UI.svg" },
        { name: "Postman", src: "https://icon.icepanel.io/Technology/svg/Postman.svg" },
        { name: "BitBucket", src: "https://icon.icepanel.io/Technology/svg/BitBucket.svg" },
        { name: "Cursor AI", src: "https://cursor.com/favicon.svg" },
        { name: "Claude AI", src: "https://images.seeklogo.com/logo-png/55/1/claude-logo-png_seeklogo-554534.png" },
        { name: "Audio to Text", src: "https://cdn6.aptoide.com/imgs/b/f/7/bf79b24f6bc55fecfaee3419607ad7e9_icon.png" },
        { name: "Sentry", src: "https://cdn.worldvectorlogo.com/logos/sentry-3.svg" },
        { name: "Prisma", src: "https://cdn.worldvectorlogo.com/logos/prisma-2.svg" },
    ],
    HERO_BG_LOAD_ERROR: "Failed to load image:",

    BLINK_MOBILITY_PAGE: {
        BACK_TO_PORTFOLIO: "Back to Portfolio",
        HERO_BADGE_1: "EV Car Share",
        HERO_BADGE_2: "Urban Mobility",
        HERO_TITLE: "Blink Mobility / BlueLA",
        HERO_DESCRIPTION:
            "Re-architected the EV car-sharing platform for scale and reliability and shipped a custom Bluetooth SDK controlling 100+ vehicles — on the engineering team through Envoy's $34M acquisition by Blink Charging (Nasdaq: BLNK).",
        HERO_COMPANY: "EnvoyThere / Blink Mobility",
        HERO_ROLE: "Senior Full-Stack Engineer",
        HERO_PERIOD: "2022 - 2024",
        OVERVIEW_TITLE: "Platform Overview",
        OVERVIEW_DESCRIPTION:
            "Rebuilt the rental platform as a microservices architecture serving two brands on shared infrastructure, migrated the mobile app from Expo to React Native and JavaScript to TypeScript, and delivered compliant KYC onboarding with instant approve/reject.",
        KEY_TITLE: "Key Features",
        KEY_METRIC_APP: "~6 Weeks",
        KEY_METRIC_PAYMENTS: "Instant",
        KEY_METRIC_VEHICLES: "100+",
        KEY_DESC_APP: "Custom BLE SDK, spec to production — no prior Bluetooth experience",
        KEY_DESC_PAYMENTS: "KYC approve/reject, replacing multi-day manual review",
        KEY_DESC_VEHICLES: "Vehicles controlled offline & online via the SDK",
        IMPLEMENTATION_TITLE: "Technical Implementation",
        IMPLEMENTATION_STACK_TITLE: "Platform Infrastructure",
        IMPLEMENTATION_STACK: ["React Native", "Node.js", "TypeScript", "Firebase", "PostgreSQL", "AWS"],
        IMPLEMENTATION_FEATURES_TITLE: "Highlights",
        IMPLEMENTATION_DESCRIPTION:
            "Microservices backend with a React Native front end, a custom BLE SDK with offline command queueing and sync, telematics integration, and secure payment processing for real-time rentals.",
        IMPLEMENTATION_FEATURES_LIST: [
            "Custom BLE SDK with offline command queueing and sync",
            "License upload and identity verification (ClearMe, Checkr)",
            "Map-based vehicle search with live battery data",
            "In-app booking and payment flow",
            "Admin dashboard for fleet management",
            "Push notifications for trip events",
        ],
        CHALLENGES_TITLE: "Challenges & Solutions",
        CHALLENGE_TRUST_TITLE: "Reliable Vehicle Access",
        CHALLENGE_TRUST_TEXT: "Designed the BLE SDK's offline command queueing and sync so vehicles unlock reliably even in low-connectivity areas.",
        CHALLENGE_TX_TITLE: "Scalable Backend",
        CHALLENGE_TX_TEXT: "Re-architected the platform into microservices serving two brands on shared infrastructure, improving scale and reliability.",
        CHALLENGE_ACCESS_TITLE: "User Onboarding",
        CHALLENGE_ACCESS_TEXT: "Built compliant KYC onboarding with instant approve/reject, replacing multi-day manual review.",
        BUSINESS_TITLE: "Business Learning & Impact",
        BUSINESS_DESCRIPTION:
            "The re-architecture carried the platform through Envoy's $34M acquisition by Blink Charging (Nasdaq: BLNK) in April 2023 — a turnaround from underperforming system to scalable, acquirable platform.",
        CTA_TITLE: "Electrify Your Fleet",
        CTA_TEXT: "This project demonstrates expertise in building app-driven car sharing with real-time EV management.",
        CTA_BUTTON: "Let's Connect",
    },
    YALLA_PIZZA_PAGE: {
        BACK_TO_PORTFOLIO: "Back to Portfolio",
        HERO_BADGE_1: "AI / POS",
        HERO_BADGE_2: "Conversational AI",
        HERO_TITLE: "Yalla Pizza",
        HERO_DESCRIPTION:
            "An AI-driven restaurant operations product: a conversational ordering bot, an operations/management bot, and real-time tracking of kitchen, stock, sales, and orders.",
        HERO_COMPANY: "Product",
        HERO_ROLE: "Architect & Lead Engineer",
        HERO_PERIOD: "2023 - Present",
        OVERVIEW_TITLE: "Product Overview",
        OVERVIEW_DESCRIPTION:
            "Yalla Pizza is an enterprise POS and operations system for restaurants. Customers order through a conversational AI bot; managers run the floor through an operations bot; and the kitchen, stock, sales, and orders are tracked live in one real-time system.",
        KEY_TITLE: "Key Highlights",
        KEY_METRIC_BOT: "2 AI Bots",
        KEY_METRIC_REALTIME: "Real-Time",
        KEY_METRIC_SCOPE: "End-to-End",
        KEY_DESC_BOT: "Conversational ordering + operations management",
        KEY_DESC_REALTIME: "Kitchen, stock, sales & orders tracked live",
        KEY_DESC_SCOPE: "Built A-Z: bots, backend, and POS",
        IMPLEMENTATION_TITLE: "Technical Implementation",
        IMPLEMENTATION_STACK_TITLE: "Technology Stack",
        IMPLEMENTATION_STACK: ["TypeScript", "Node.js", "React", "PostgreSQL", "WebSockets", "LLM APIs"],
        IMPLEMENTATION_FEATURES_TITLE: "Core Capabilities",
        IMPLEMENTATION_DESCRIPTION:
            "A real-time operations core with conversational interfaces layered on top — built and shipped end-to-end as a single engineering effort.",
        IMPLEMENTATION_FEATURES_LIST: [
            "Conversational AI ordering bot for customers",
            "Operations/management bot for daily restaurant workflows",
            "Real-time kitchen operations tracking",
            "Live stock, sales, and order monitoring",
            "POS integration across the full order lifecycle",
        ],
        CHALLENGES_TITLE: "Challenges & Solutions",
        CHALLENGE_REALTIME_TITLE: "Real-Time Consistency",
        CHALLENGE_REALTIME_TEXT:
            "Kept kitchen, stock, and order state consistent across concurrent stations using WebSocket-driven updates and a single source of truth.",
        CHALLENGE_BOT_TITLE: "Conversational Ordering",
        CHALLENGE_BOT_TEXT: "Designed the ordering bot's conversational flow to handle menu navigation, customization, and order confirmation reliably.",
        CHALLENGE_OPS_TITLE: "Operational Fit",
        CHALLENGE_OPS_TEXT: "Shaped the system around real kitchen workflows so tracking matches how staff actually work during service.",
        BUSINESS_TITLE: "Product Thinking",
        BUSINESS_DESCRIPTION:
            "Yalla Pizza shows the full arc of applied AI product work: a conversational interface on top of a real-time operational system, built A-Z and used in day-to-day restaurant operations.",
        CTA_TITLE: "Conversational AI for Operations",
        CTA_TEXT: "This product demonstrates how conversational AI and real-time systems combine into practical operations tooling.",
        CTA_BUTTON: "Discuss Your Product",
    },
    AWANEEK_PAGE: {
        BACK_TO_PORTFOLIO: "Back to Portfolio",
        HERO_BADGE_1: "AI / E-commerce",
        HERO_BADGE_2: "Automation",
        HERO_TITLE: "Awaneek",
        HERO_DESCRIPTION:
            "An AI-powered e-commerce platform that automatically verifies product legality, helping marketplaces and sellers stay compliant at scale.",
        HERO_COMPANY: "Product",
        HERO_ROLE: "Architect & Lead Engineer",
        HERO_PERIOD: "2022 - Present",
        OVERVIEW_TITLE: "Product Vision",
        OVERVIEW_DESCRIPTION:
            "Awaneek applies AI to a hard e-commerce problem: verifying that listed products are legal and compliant before they go live. The platform combines automated analysis with a full storefront stack — digital catalogs, ordering, and real-time tracking.",
        KEY_TITLE: "Key Highlights",
        KEY_METRIC_SETUP: "AI Verification",
        KEY_METRIC_ORDERS: "Live Orders",
        KEY_METRIC_SECURE: "Secure Payouts",
        KEY_DESC_SETUP: "Automated product-legality checks",
        KEY_DESC_ORDERS: "Real-time tracking",
        KEY_DESC_SECURE: "Safe payments",
        IMPLEMENTATION_TITLE: "Technical Implementation",
        IMPLEMENTATION_STACK_TITLE: "Technology Stack",
        IMPLEMENTATION_STACK: ["React", "Node.js", "TypeScript", "MongoDB", "Firebase", "AWS", "Stripe", "LLM APIs"],
        IMPLEMENTATION_FEATURES_TITLE: "Core Features",
        IMPLEMENTATION_DESCRIPTION:
            "Built with modern web technologies to deliver a scalable platform that combines AI-driven compliance checks with live inventory, secure payments, and real-time updates across all devices.",
        IMPLEMENTATION_FEATURES_LIST: [
            "AI-powered product-legality verification",
            "Digital catalogs and online ordering",
            "Live inventory and sales tracking",
            "Remote notifications for shop owners",
            "Built-in marketing and analytics tools",
            "Secure payments and easy payouts",
        ],
        CHALLENGES_TITLE: "Challenges & Solutions",
        CHALLENGE_INFRA_TITLE: "Real-Time Infrastructure",
        CHALLENGE_INFRA_TEXT: "Implemented reliable websockets and background workers to keep orders, inventory and notifications in sync at all times.",
        CHALLENGE_UX_TITLE: "AI Compliance Checks",
        CHALLENGE_UX_TEXT: "Designed an AI verification flow that flags questionable products automatically while keeping false positives reviewable.",
        CHALLENGE_SCALE_TITLE: "Scalable Architecture",
        CHALLENGE_SCALE_TEXT: "Built a cloud-native architecture to handle growing traffic while keeping the platform responsive and cost efficient.",
        BUSINESS_TITLE: "Business Learning & Impact",
        BUSINESS_DESCRIPTION:
            "Building Awaneek shows how AI can be applied beyond chat — as an automated compliance layer inside a commerce platform, running autonomously and supporting owners from anywhere.",
        CTA_TITLE: "AI-Powered Commerce",
        CTA_TEXT: "This project demonstrates applying AI to real marketplace problems like product-legality verification.",
        CTA_BUTTON: "Get Started",
    },
    NATRAROSA_PAGE: {
        BACK_TO_PORTFOLIO: "Back to Portfolio",
        HERO_BADGE_1: "Salon & Florist",
        HERO_BADGE_2: "E-commerce",
        HERO_TITLE: "Natrarosa",
        HERO_DESCRIPTION:
            "Natrarosa helps salons and flower shops launch free online stores with digital menus, live order tracking and built-in marketing tools.",
        HERO_COMPANY: "Personal Venture",
        HERO_ROLE: "Founder & Developer",
        HERO_PERIOD: "2023 - Present",
        OVERVIEW_TITLE: "Venture Vision",
        OVERVIEW_DESCRIPTION:
            "Natrarosa was built to empower small salons and florists with modern e-commerce capabilities. The goal is to simplify online store creation and provide real-time tools that help owners track orders, engage customers and grow sales without any coding knowledge.",
        KEY_TITLE: "Key Highlights",
        KEY_METRIC_SETUP: "Free Setup",
        KEY_METRIC_TRACKING: "Live Tracking",
        KEY_METRIC_REMOTE: "Remote",
        KEY_DESC_SETUP: "Online Store Creation",
        KEY_DESC_TRACKING: "Orders & Customers",
        KEY_DESC_REMOTE: "Shop Monitoring",
        IMPLEMENTATION_TITLE: "Technical Implementation",
        IMPLEMENTATION_STACK_TITLE: "Technology Stack",
        IMPLEMENTATION_STACK: ["React", "Node.js", "TypeScript", "MongoDB", "Stripe", "AWS", "React Native", "Next.js"],
        IMPLEMENTATION_FEATURES_TITLE: "Core Features",
        IMPLEMENTATION_DESCRIPTION:
            "Built with modern web technologies to ensure scalability, performance, and an excellent user experience across all devices.",
        IMPLEMENTATION_FEATURES_LIST: [
            "Free online store setup through a simple form",
            "Digital menus for services and bouquets",
            "Real-time notifications and live order tracking",
            "Marketing and analytics dashboard",
            "Inventory, payment and scheduling tools",
            "Remote shop monitoring from any device",
        ],
        CHALLENGES_TITLE: "Challenges & Learning",
        CHALLENGE_RESEARCH_TITLE: "Industry Research",
        CHALLENGE_RESEARCH_TEXT: "Spent considerable time understanding the unique needs of salons and florists in order to tailor the platform's features.",
        CHALLENGE_REALTIME_TITLE: "Real-Time Infrastructure",
        CHALLENGE_REALTIME_TEXT: "Implemented live order tracking and instant notifications using modern web technologies.",
        CHALLENGE_EASE_TITLE: "Ease of Use",
        CHALLENGE_EASE_TEXT: "Focused on delivering a no-code experience so business owners can manage everything without technical skills.",
        BUSINESS_TITLE: "Business Learning & Impact",
        BUSINESS_DESCRIPTION:
            "Building Natrarosa gave me first-hand experience in crafting specialized e-commerce tools for niche service businesses. It highlights my ability to take a concept from idea to a fully functional platform that helps local entrepreneurs thrive online.",
        CTA_TITLE: "Bring Your Shop Online",
        CTA_TEXT: "Ready to modernize your salon or flower shop? Let's discuss how Natrarosa can help.",
        CTA_BUTTON: "Get Started Today",
    },
} as const;
